import * as XLSX from "xlsx";

/**
 * Generate and download a template xlsx file for movement import
 */
export function downloadMovimientoTemplate(): void {
  // Create workbook and worksheet
  const wb = XLSX.utils.book_new();

  // Header row + example data
  const data = [
    ["Cuenta", "Descripcion", "Debe", "Haber"],
    ["4101001", "Ejemplo - Venta al contado", "", "100000"],
    ["1104050", "Ejemplo - Cuenta por cobrar cliente", "100000", ""],
  ];

  const ws = XLSX.utils.aoa_to_sheet(data);

  // Set column widths for better readability
  ws["!cols"] = [
    { wch: 12 }, // Cuenta
    { wch: 45 }, // Descripcion
    { wch: 15 }, // Debe
    { wch: 15 }, // Haber
  ];

  XLSX.utils.book_append_sheet(wb, ws, "Comprobante");

  // Generate and trigger download
  XLSX.writeFile(wb, "plantilla_comprobante.xlsx");
}
